var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","appendToBody":false,"footerButton":_vm.footerButton,"title":_vm.title}},[_c('innerOrg',{ref:"org",attrs:{"params":_vm.params}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1b89894","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/public-dialog/form/org-select.vue
// module id = 1092
// module chunks = 0 1